module.exports = __webpack_public_path__ + "static/Starsteaders Logo-7becc822a1a02172f921d7c6d252d26e.png";